import { FullBooking } from '@alluradirect/react';
import { Typography } from '@mui/material';
import ConfirmationDialog from 'components/core/ConfirmationDialog/ConfirmationDialog';
import Grid from 'components/core/Grid';
import { damageDepositDescription } from 'components/views/pages/Checkout/CheckoutSummary/helpers';
import { BookingCheckoutResponse } from 'components/views/pages/Checkout/hooks/useCheckout';

interface Props {
  isOpen: boolean;
  close: () => void;
  checkoutData: BookingCheckoutResponse | undefined;
  bookingData: FullBooking | undefined;
  isLastStep: boolean;
}

export const CheckoutSummaryDamageDepositDialog = ({ isOpen, close, checkoutData, bookingData, isLastStep }: Props) => {
  const description = damageDepositDescription({ checkoutData, bookingData, isLastStep });

  return (
    <ConfirmationDialog
      isDialogOpen={isOpen}
      handleCloseDialog={close}
      hasBottomBar={false}
      dialogTitle="Damage Deposit"
      useIsXs={false}
      maxWidth="xs"
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="body2">{description}</Typography>
        </Grid>
      </Grid>
    </ConfirmationDialog>
  );
};
